<!--
    @修改人：黎柏祺
    @修改时间：2018-11-28
    @修改描述：框架升级
    @版本:v1.0.26
    ------------
    @负责人: 黎柏祺
    @创建时间: 2018-05-15
    @版本:v1.0.16
    @描述: 编辑告警组件
    -->
<template>
  <div class="editStratagy__content">
    <g-back :history="history"></g-back>
    <div class="editStratagy__form">
      <el-form ref="form"
        :model="form"
        :inline="true"
        label-width="100px"
        :rules="rules">
        <el-form-item :label="$t('alarmStrategy.alarmName')"
          prop="alarmName">
          <el-input v-model="form.alarmName"></el-input>
        </el-form-item>
        <el-form-item :label="$t('alarmStrategy.alarmType')">
          <g-select :list="select_alarmType"
            v-model="form.alarmType"></g-select>
        </el-form-item>
        <el-form-item :label="$t('alarmStrategy.alarmTag')"
          v-show="form.sourceType==='2'">
          <el-input v-model="form.tag"></el-input>
        </el-form-item>
        <el-form-item :label="$t('alarmStrategy.alarmLevel')"
          v-show="form.sourceType!=='1'">
          <g-select :list="select_alarmLevel"
            v-model="form.alarmLevel"></g-select>
        </el-form-item>
        <el-form-item :label="$t('alarmStrategy.appName')">
          <g-select :list="appList"
            v-model="form.appName"
            tdisabled></g-select>
        </el-form-item>
        <el-form-item :label="$t('alarmStrategy.triggerStyle')">
          <g-select :list="select_triggerStyle"
            v-model="form.trgType"></g-select>
        </el-form-item>
        <el-form-item :label="form.sourceType==='1'?$t('alarmStrategy.kpiKey'):$t('alarmStrategy.alarmKey')">
          <el-input v-model="kpiDesc"
            disabled></el-input>
        </el-form-item>
        <el-form-item :label="$t('alarmStrategy.alarmCode')"
          prop="alarmCode">
          <el-input v-model="form.alarmCode"></el-input>
        </el-form-item>
        <el-form-item :label="$t('alarmStrategy.appGroup')">
          <g-select :list="groupList"
            v-model="form.group"
            tdisabled></g-select>
        </el-form-item>
        <el-form-item :label="$t('logComponentManage.site')"
          prop="siteCode">
          <g-select :list="siteList"
            v-model="form.siteCode"
            tdisabled></g-select>
        </el-form-item>
        <el-form-item :label="$t('alarmStrategy.timingOn')"
          v-show="!form.enable">
          <el-input-number style="width: 102px"
            :min="0"
            v-model="form.timer"></el-input-number>
          <g-select style="width: 74px"
            v-model="form.unit"
            :list="select_timeUnit"></g-select>
        </el-form-item>
        <el-form-item :label="$t('alarmStrategy.alarmSource')"
          v-if="form.sourceType==='3'">
          <el-input v-model="form.alarmSource"></el-input>
        </el-form-item>
        <el-form-item :label="$t('alarmStrategy.enable')"
          class="editStratagy__w700">
          <el-radio v-model="form.enable"
            :label="true">{{$t('alarmStrategy.yes')}}</el-radio>
          <el-radio v-model="form.enable"
            :label="false">{{$t('alarmStrategy.no')}}</el-radio>
        </el-form-item>
        <el-form-item :label="$t('alarmStrategy.mailGroups')">
          <div class="editAlarmStratagy__checkbox">
            <el-checkbox-group v-model="form.mailGroups">
              <el-checkbox v-for="(item,index) in userGroups"
                :label="item"
                :key="index"
                class="editAlarmStratagy__checkItem"></el-checkbox>
            </el-checkbox-group>
          </div>
        </el-form-item>
        <el-form-item :label="$t('alarmStrategy.messageGroups')">
          <div class="editAlarmStratagy__checkbox">
            <el-checkbox-group v-model="form.messageGroups">
              <el-checkbox v-for="(item,index) in userGroups"
                :label="item"
                :key="index"
                class="editAlarmStratagy__checkItem"></el-checkbox>
            </el-checkbox-group>
          </div>
        </el-form-item>
        <el-form-item :label="$t('alarmStrategy.alarmRule')"
          class="editStratagy__w700"
          v-if="form.sourceType==='1'">
          <dynamic-table ref="dynamicTable"
            :input-data="inputDatas"
            :model="tableModels"
            :add-fun="getDdatas"
            :custom-fun="deleteDdatas">
            <el-button :slot="'operation'+index"
              v-for="(item,index) in tData"
              :key="index"
              :class="[item.processSteps !==null&&item.processSteps.length!==0?'el-button--primary':'none']"
              @click="addTreatProcess(item,index)">
              &nbsp;&nbsp;{ }&nbsp;&nbsp;
            </el-button>
          </dynamic-table>
        </el-form-item>
        <el-form-item :label="$t('alarmStrategy.alarmRule')"
          class="editStratagy__w700"
          v-if="form.sourceType==='2'">
          <dynamic-table ref="dynamicTable"
            :input-data="inputData"
            :model="tableModel"
            :custom-fun="deleteDdata">
          </dynamic-table>
        </el-form-item>
        <el-form-item :label="$t('alarmStrategy.alarmMapRule')"
          class="editStratagy__w700"
          v-if="form.sourceType==='2'">
          <table class="t-tableMin t-table">
            <thead>
              <tr class="kpi-t-title">
                <th class="t-border t-map">{{$t('alarmStrategy.tagField')}}</th>
                <th class="t-border t-map">{{$t('alarmStrategy.tagFieldType')}}</th>
                <th class="t-border t-map">{{$t('alarmStrategy.sourceField')}}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="t-border t-nopd"
                  v-text="$t('alarmStrategy.alarmObject')"></td>
                <td class="t-border t-nopd"
                  v-text="'STRING'"></td>
                <td class="t-border t-nopd">
                  <el-input v-model="alarmMapRule[0].sourceField"></el-input>
                </td>
              </tr>
              <tr>
                <td class="t-border t-nopd"
                  v-text="$t('alarmStrategy.alarmAddress')"></td>
                <td class="t-border t-nopd"
                  v-text="'STRING'"></td>
                <td class="t-border t-nopd">
                  <el-input v-model="alarmMapRule[1].sourceField"></el-input>
                </td>
              </tr>
              <tr>
                <td class="t-border t-nopd"
                  v-text="$t('alarmStrategy.alarmTime')"></td>
                <td class="t-border t-nopd"
                  v-text="'LONG'"></td>
                <td class="t-border t-nopd">
                  <el-input v-model="alarmMapRule[2].sourceField"></el-input>
                </td>
              </tr>
              <tr>
                <td class="t-border t-nopd"
                  v-text="$t('alarmStrategy.alarmContent')"></td>
                <td class="t-border t-nopd"
                  v-text="'STRING'"></td>
                <td class="t-border t-nopd">
                  <el-input v-model="alarmMapRule[3].sourceField"></el-input>
                </td>
              </tr>
              <tr>
                <td class="t-border t-nopd"
                  v-text="$t('alarmStrategy.locationInfo')"></td>
                <td class="t-border t-nopd"
                  v-text="'STRING'"></td>
                <td class="t-border t-nopd">
                  <el-input v-model="alarmMapRule[4].sourceField"></el-input>
                </td>
              </tr>
            </tbody>
          </table>
        </el-form-item>
        <el-form-item :label="$t('alarmStrategy.processPlan')"
          prop="processPlan"
          class="editStratagy__w700">
          <el-input v-model="form.processPlan"
            type="textarea"
            class="editStratagy__w500"
            :autosize="{ minRows: 5}"></el-input>
        </el-form-item>
        <el-form-item :label="$t('alarmStrategy.remarks')"
          class="editStratagy__w700"
          v-if="form.sourceType === '3'">
          <el-input v-model="form.remarks"
            type="textarea"
            class="editStratagy__w500"
            :autosize="{ minRows: 5}"></el-input>
        </el-form-item>
        <el-form-item class="editStratagy__center">
          <el-button type="primary"
            v-g-rac="gRac('alarmStrategy_amend')"
            @click="e_save">{{ $t('common.save') }}</el-button>
          <el-button @click="e_cancel">{{ $t('common.cancel') }}</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-dialog :closeOnClickModal="false"
      :title="$t('alarmStrategy.processSteps')"
      :visible.sync="dialogVisible">
      <el-form ref="processForm">
        <div v-for="(item,index) in processSteps"
          :key="index"
          class="mb-base">
          {{$t('alarmStrategy.step')}}{{index + 1}}
          <el-input class="editStratagy__w200 mb-base"
            v-model="item.stepName"></el-input>
          <el-button type="danger"
            @click="deleteStep(index)">{{$t('alarmStrategy.delete')}}</el-button>
          <el-input v-model="item.action"
            type="textarea"
            :autosize="{ minRows: 5}"></el-input>
        </div>
        <div>
          <el-button type="primary"
            @click="addStep">{{$t('alarmStrategy.add')}}</el-button>
        </div>
      </el-form>
      <div slot="footer"
        class="dialog-footer">
        <el-button @click="closeDialog">{{$t('common.cancel')}}</el-button>
        <el-button type="primary"
          @click="e_saveTreatProcess">{{$t('common.save')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import SiteListBiz from "@/logic/cmdb/cmdbBiz";
import alarmStrategyBiz from "@/logic/systemSetting/alarmStrategyBiz.js";
import validateConfig from "@/utils/validate";
import dic from "@/components/mixins/dic";
import rac from "@/plugins/rac-mixin.js";
import alarmSubscribeBiz from "@/logic/systemSetting/alarmSubscribeBiz.js";
import dynamicTable from "@/components/dynamicTable";
import { extend } from "@/utils/tool";
export default {
  mixins: [dic, rac],
  data() {
    const that = this;
    return {
      form: {
        alarmCode: null,
        alarmName: null,
        alarmLevel: null,
        alarmMapRule: null,
        alarmRules: null,
        alarmType: null,
        appName: null,
        charity: null,
        siteCode: "",
        enable: null,
        group: null,
        id: null,
        kpiKey: null,
        mailGroups: null,
        messageGroups: null,
        processPlan: null,
        sourceType: null,
        tag: null,
        trgType: null,
        timer: 0,
        unit: "H"
      },
      alarmMapRule: [
        {
          tagField: "alarmObject",
          tagFieldType: "STRING",
          sourceField: ""
        },
        {
          tagField: "alarmAddress",
          tagFieldType: "STRING",
          sourceField: ""
        },
        {
          tagField: "alarmTime",
          tagFieldType: "LONG",
          sourceField: ""
        },
        {
          tagField: "alarmContent",
          tagFieldType: "STRING",
          sourceField: ""
        },
        {
          tagField: "locationInfo",
          tagFieldType: "STRING",
          sourceField: ""
        }
      ],
      appList: {},
      isIndeterminate: true,
      checkAll: false,
      dialogVisible: false,
      rules: {},
      alarmRules: [],
      processSteps: [],
      select_alarmType: {},
      select_alarmLevel: {},
      select_triggerStyle: {},
      siteList: {},
      userGroups: {},
      kpiKeyList: {},
      kpiTypeList: [],
      allKpiData: [],
      kpiType: "",
      kpiDesc: "",
      alarmRuleList: {},
      alarmCountType: "",
      mailGroupsSelect: {},
      msgGroupsSelect: {},
      alarmCountTypeList: {},
      timeList: {},
      enableList: {
        yes: that.$t("alarmStrategy.yes"),
        no: that.$t("alarmStrategy.no")
      },
      processList: [],
      processIndex: null,
      alarmCode: "",
      history: [],
      inputData: [],
      tableModel: {},
      inputDatas: [],
      groupList: {},
      tableModels: {},
      tData: [],
      select_timeUnit: {}
    };
  },
  computed: {},
  methods: {
    e_init() {
      let timeArr = {
        none: "--"
      };
      for (let i = 0; i < 24; i++) {
        timeArr[i] = i;
      }
      this.timeList = timeArr;
      this.history = [];
      this.history.push({ name: this.$t("alarmStrategy.editAlarmStrategy") });
      this.waitAppList();
      this.waitGroupList();
      this.waitaAlarmType();
      this.waitAlarmLevel();
      this.getSiteList();
      this.waitTriggertype();
      this.waitAlarmRule();
      this.waitAlarmCountType();
      this.waitTimeUnit();
      this.findUserGroups();
      this.setRule();
      this.init();
    },
    async waitAppList(group) {
      await this.dGetAppByGroup("", group);
      this.appList = { ...this.dDictionaryApp[group] };
    },
    async waitGroupList() {
      await this.dGetGroup();
      this.groupList = this.$store.state.dicModule.group;
    },
    async waitaAlarmType() {
      await this.dGetDictionaryByCode("alarmType");
      this.select_alarmType = { ...this.dDictionary.alarmType };
    },
    async waitAlarmLevel() {
      await this.dGetDictionaryByCode("alarmLevel");
      this.select_alarmLevel = { ...this.dDictionary.alarmLevel };
    },
    async waitTriggertype() {
      await this.dGetDictionaryByCode("triggertype");
      this.select_triggerStyle = { ...this.dDictionary.triggertype };
    },
    async waitTimeUnit() {
      await this.dGetDictionaryByCode("timeunittype");
      this.select_timeUnit = { ...this.dDictionary.timeunittype };
    },
    async waitAlarmRule() {
      await this.dGetDictionaryByCode("alarmRule");
      this.alarmRuleList = { ...this.dDictionary.alarmRule };
      setTimeout(() => {
        this.setDynamicData();
      }, 100);
    },
    async waitAlarmCountType() {
      await this.dGetDictionaryByCode("alarmCountType");
      this.alarmCountTypeList = { ...this.dDictionary.alarmCountType };
      for (let key in this.alarmCountTypeList) {
        this.alarmCountType = key;
        return;
      }
    },
    getSiteList() {
      if (Object.keys(this.siteList).length === 0) {
        SiteListBiz.siteList({ perPageCount: 500 }).then(data => {
          let list = {};
          data.dataList.map(item => {
            list[item.siteCode] = item.name;
          });
          this.siteList = list;
        });
      }
    },
    setRule() {
      const array = ["alarmName", "alarmCode", "charity", "processPlan"];
      array.map(item => {
        this.rules[item] = [{ ...validateConfig.common.notEmpty }];
      });
    },
    setDynamicData() {
      this.inputData = [
        {
          label: this.$t("alarmStrategy.field"),
          key: "field"
        },
        {
          label: this.$t("alarmStrategy.rule"),
          key: "rule",
          type: "select",
          select: this.alarmRuleList
        },
        {
          label: this.$t("alarmStrategy.value"),
          key: "value"
        },
        {
          label: this.$t("alarmStrategy.alarmMoment"),
          type: "rangeSelect",
          fkey: "startTime",
          skey: "endTime",
          select: this.timeList
        }
      ];
      this.tableModel = {
        rule: Object.keys(this.alarmRuleList)[0],
        value: "",
        field: "",
        startTime: "none",
        endTime: "none"
      };
      this.inputDatas = [
        {
          label: this.$t("alarmStrategy.kpiKey"),
          key: "kpiKey",
          disabled: true
        },
        {
          label: this.$t("alarmStrategy.rule"),
          key: "rule",
          type: "select",
          select: this.alarmRuleList
        },
        {
          label: this.$t("alarmStrategy.value"),
          key: "value"
        },
        {
          label: this.$t("alarmStrategy.duration"),
          key: "triggerTime",
          disabled: this.form.trgType === "1"
        },
        {
          label: this.$t("alarmStrategy.alarmMoment"),
          type: "rangeSelect",
          fkey: "startTime",
          skey: "endTime",
          select: this.timeList
        },
        {
          label: this.$t("alarmStrategy.alarmLevel"),
          type: "select",
          key: "alarmLevel",
          select: this.select_alarmLevel
        },
        {
          label: this.$t("alarmStrategy.alarmCountType"),
          type: "select",
          key: "countType",
          select: this.alarmCountTypeList
        }
      ];
      this.tableModels = {
        kpiKey: this.kpiDesc,
        rule: Object.keys(this.alarmRuleList)[0],
        value: "",
        triggerTime: this.form.trgType !== "1" ? "" : 0,
        alarmLevel: Object.keys(this.select_alarmLevel)[0],
        countType: Object.keys(this.alarmCountTypeList)[0],
        startTime: "none",
        endTime: "none",
        processSteps: []
      };
    },
    getDdatas(val) {
      this.tData = extend(true, [], val);
    },
    deleteDdatas(item, i) {
      const d = this.$refs.dynamicTable.getData();
      d.splice(i, 1);
      this.tData = d;
      this.$refs.dynamicTable.setData(d);
    },
    deleteDdata(item, i) {
      const d = this.$refs.dynamicTable.getData();
      d.splice(i, 1);
      this.$refs.dynamicTable.setData(d);
    },
    init() {
      setTimeout(() => {
        this.alarmCode = this.$route.query.alarmCode;
        setTimeout(() => {
          this.getAll();
        }, 100);
      }, 100);
    },
    closeDialog() {
      this.dialogVisible = false;
    },
    addStep() {
      let obj = {
        action: "",
        stepName: ""
      };
      this.processSteps.push(obj);
    },
    deleteStep(i) {
      this.processSteps.splice(i, 1);
    },
    findUserGroups() {
      alarmSubscribeBiz.getGroup({ perPageCount: 500 }).then(data => {
        const userGroupArr = [];
        data.dataList.forEach(function(item) {
          userGroupArr[item.groupName] = item.groupName;
        });
        this.userGroups = { ...userGroupArr };
      });
    },
    findKpiKeys() {
      const that = this;
      const info = {
        group: this.form.group,
        appName: this.form.appName,
        currentPage: 1,
        perPageCount: 50
      };
      alarmSubscribeBiz.getKpiKey(info).then(function(data) {
        let kpiKeyList = {};
        that.kpiTypeList = [];
        that.allKpiData = data.dataList;
        that.allKpiData.forEach(function(item) {
          kpiKeyList[item.kpiKey] = item.desc;
          that.kpiTypeList.push(item.kpiType);
        });
        that.kpiKeyList = { ...kpiKeyList };
        that.kpiDesc =
          that.kpiKeyList[that.form.kpiKey] === undefined
            ? that.form.kpiKey
            : that.kpiKeyList[that.form.kpiKey];
        let d = [...that.$refs.dynamicTable.getData()];
        d.forEach(item => {
          item.kpiKey = that.kpiDesc;
        });
        that.$refs.dynamicTable.setData(d);
        that.tableModels.kpiKey = that.kpiDesc;
        if (that.allKpiData.length !== 0) {
          for (let i = 0; i < that.allKpiData.length; i++) {
            if (that.allKpiData[i].kpiKey === that.form.kpiKey) {
              that.kpiType = that.allKpiData[i].kpiType;
              break;
            } else {
              that.kpiType = that.allKpiData[0].kpiType;
            }
          }
        }
      });
    },
    addTable() {
      let obj = {
        rule: Object.keys(this.alarmRuleList)[0],
        value: "",
        triggerTime: this.form.trgType === "1" ? 0 : "",
        alarmLevel: Object.keys(this.select_alarmLevel)[0],
        countType: Object.keys(this.alarmCountTypeList)[0],
        startTime: "none",
        endTime: "none",
        processSteps: []
      };
      this.alarmRules.push(obj);
    },
    addTreatProcess(d, i) {
      this.dialogVisible = true;
      this.processSteps =
        d.processSteps === null ? [] : extend(true, [], d.processSteps);
      this.processIndex = i;
    },
    e_saveTreatProcess() {
      for (let i in this.processSteps) {
        if (this.processSteps[i].stepName === "") {
          this.$message({
            message: this.$t("alarmStrategy.rules.stepName"),
            type: "warning"
          });
          return;
        }
      }
      const d = this.$refs.dynamicTable.getData();
      d[this.processIndex].processSteps = this.processSteps;
      this.tData = d;
      this.$refs.dynamicTable.setData(d);
      this.dialogVisible = false;
    },
    e_cancel() {
      this.$router.push({ name: "alarmStrategy" });
    },
    e_save() {
      if (this.form.sourceType === "3") return this._save();
      this.alarmRules = [...this.$refs.dynamicTable.getData()];
      this.form.alarmRules = [...this.$refs.dynamicTable.getData()];
      this.$refs.form.validate(valid => {
        if (valid) {
          for (let i in this.form.alarmRules) {
            if (this.form.alarmRules[i].value === "") {
              this.$message({
                message: this.$t("alarmStrategy.rules.value"),
                type: "warning"
              });
              return;
            }
            if (this.form.alarmRules[i].triggerTime === "") {
              this.$message({
                message: this.$t("alarmStrategy.rules.triggerTime"),
                type: "warning"
              });
              return;
            }
            if (this.form.alarmRules[i].startTime === "none") {
              this.form.alarmRules[i].startTime = null;
            }
            if (this.form.alarmRules[i].endTime === "none") {
              this.form.alarmRules[i].endTime = null;
            }
            if (this.form.enable) {
              this.form.timer = null;
              this.form.unit = null;
            }
            delete this.form.alarmRules[i].advise;
            delete this.form.alarmRules[i].duration;
            delete this.form.alarmRules[i].condition;
            if (this.form.sourceType === "2") {
              delete this.form.alarmRules[i].processSteps;
              delete this.form.alarmRules[i].triggerTime;
              delete this.form.alarmRules[i].countType;
              delete this.form.alarmRules[i].alarmLevel;
            }
            if (this.form.sourceType !== "2") {
              delete this.form.alarmRules[i].field;
            }
          }
          if (this.form.sourceType === "2") {
            this.form.alarmMapRule = this.alarmMapRule;
          }
          if (this.form.sourceType !== "2") {
            delete this.form.alarmMapRule;
          }
          this.form.alarmRules.forEach((item, index) => {
            delete item.kpiKey;
          });
          alarmStrategyBiz.changeStrategy(this.form).then(data => {
            this.$message({
              message: this.$t("common.success"),
              type: "success"
            });
            setTimeout(() => {
              this.$router.push({ name: "alarmStrategy" });
            }, 500);
          });
        }
      });
    },
    _save() {
      this.$refs.form.validate(valid => {
        if (valid) {
          alarmStrategyBiz.changeStrategy(this.form).then(data => {
            this.$message({
              message: this.$t("common.success"),
              type: "success"
            });
            setTimeout(() => {
              this.$router.push({ name: "alarmStrategy" });
            }, 500);
          });
        }
      });
    },
    getAll() {
      const that = this;
      alarmStrategyBiz.findAll({ alarmCode: that.alarmCode }).then(function(d) {
        that.form = extend(true, {}, d.dataList[0]);
        delete that.form.alarmObject;
        that.alarmRules =
          that.form.alarmRules !== null ? that.form.alarmRules : [];
        setTimeout(() => {
          that.alarmRules.forEach((item, index) => {
            if (item.startTime === null) {
              item.startTime = "none";
            }
            if (item.endTime === null) {
              item.endTime = "none";
            }
          });
          that.$refs.dynamicTable &&
            that.$refs.dynamicTable.setData(that.alarmRules);
          if (that.form.sourceType === "1") {
            that.tData = that.form.alarmRules;
            that.findKpiKeys();
          }
          if (that.form.sourceType !== "1") {
            that.kpiDesc = that.form.kpiKey;
          }
          if (that.form.alarmMapRule !== null) {
            that.alarmMapRule.forEach(item => {
              that.form.alarmMapRule.forEach(d => {
                if (item.tagField === d.tagField) {
                  item.sourceField = d.sourceField;
                }
              });
            });
          }
        }, 0);
      });
    },
    resetForm() {
      this.alarmMapRule = [
        {
          tagField: "alarmObject",
          tagFieldType: "STRING",
          sourceField: ""
        },
        {
          tagField: "alarmAddress",
          tagFieldType: "STRING",
          sourceField: ""
        },
        {
          tagField: "alarmTime",
          tagFieldType: "LONG",
          sourceField: ""
        },
        {
          tagField: "alarmContent",
          tagFieldType: "STRING",
          sourceField: ""
        },
        {
          tagField: "locationInfo",
          tagFieldType: "STRING",
          sourceField: ""
        }
      ];
      this.kpiKeyList = {};
      this.kpiTypeList = [];
      this.allKpiData = [];
      this.checkAll = false;
      this.kpiType = "";
      this.kpiDesc = "";
      this.processList = [];
      this.processIndex = null;
      this.alarmCode = "";
      this.history = [];
      this.tData = [];
      if (this.$refs.dynamicTable) this.$refs.dynamicTable.setData(this.tData);
    }
  },
  components: {
    dynamicTable
  },
  watch: {
    "form.trgType"(val) {
      if (!this.$refs.dynamicTable) return;
      this.inputDatas.forEach((item, index) => {
        if (
          this.form.trgType === "1" &&
          item.label === this.$t("alarmStrategy.duration")
        ) {
          item.disabled = true;
          this.tableModels.triggerTime = 0;
          let data = [...this.$refs.dynamicTable.getData()];
          data.forEach(item => {
            item.triggerTime = 0;
          });
          this.$refs.dynamicTable.setData(data);
        } else if (
          this.form.trgType !== "1" &&
          item.label === this.$t("alarmStrategy.duration")
        ) {
          item.disabled = false;
          this.tableModels.triggerTime = "";
          let data = [...this.$refs.dynamicTable.getData()];
          data.forEach(item => {
            item.triggerTime = "";
          });
          this.$refs.dynamicTable.setData(data);
        }
      });
    },
    "form.enable"(val) {
      if (!this.form.unit) {
        this.form.unit = "H";
        this.form.timer = 2;
      }
    },
    kpiType(val) {
      if (val === "KPICOUNT") {
        this.inputDatas.forEach(item => {
          if (item.label === this.$t("alarmStrategy.alarmCountType")) {
            item.disabled = false;
          }
        });
      } else {
        let data = [...this.$refs.dynamicTable.getData()];
        data.forEach(item => {
          item.countType = Object.keys(this.alarmCountTypeList)[0];
        });
        this.$refs.dynamicTable.setData(data);
        this.inputDatas.forEach(item => {
          if (item.label === this.$t("alarmStrategy.alarmCountType")) {
            item.disabled = true;
          }
        });
      }
    },
    $route(to, from) {
      if (to.name === "editStrategy" && from.name === "alarmStrategy") {
        this.findUserGroups();
        this.resetForm();
        this.init();
        this.history = [];
        this.history.push({ name: this.$t("alarmStrategy.editAlarmStrategy") });
      } else if (to.name === "editStrategy" && from.name !== "alarmStrategy") {
        this.e_init();
      }
    }
  },
  mounted() {
    this.e_init();
  }
};
</script>
<style scoped>
.editStratagy__content .t-table {
  display: inline-table;
  width: 850px;
  border-collapse: collapse;
  vertical-align: middle;
}
.editStratagy__content .t-table.t-tableMin {
  width: 500px;
}
.editStratagy__content .t-border {
  height: 30px;
  width: 90px;
  padding-left: 8px;
  text-align: left;
  border: 1px solid #ddd;
}
.editStratagy__content .t-border-none {
  border: none;
}
.editStratagy__content .btn-width {
  width: 46px;
}
.editStratagy__content .t-nopd {
  padding-left: 0px;
  text-align: center;
}
.editStratagy__content .btn.btn-width {
  width: 33px;
  min-width: 33px;
}
.editStratagy__content .alarmMonent.t-border {
  width: 153px;
}
.editStratagy__content .alarmMonent.t-border div {
  display: inline-block;
}
.editStratagy__content .alarmMonent .to {
  text-align: center;
  display: inline-block;
}
.editStratagy__content .editAlarmStratagy__checkbox {
  display: block;
  width: 200px;
  border: 1px solid #ddd;
  height: 120px;
  overflow-y: scroll;
  padding: 2px 4px;
}
.editStratagy__content .t-border.t-map {
  width: 200px;
  text-align: center;
}
.editStratagy__form {
  width: 800px;
}
.editStratagy__content .editStratagy__w700 {
  width: 700px;
}
.editStratagy__content .editStratagy__w500 {
  width: 500px;
}
.editStratagy__content .editAlarmStratagy__checkItem {
  margin-left: 0px;
  margin-right: 10px;
}
.editStratagy__content .editAlarmStratagy__checkbox--large {
  width: 500px;
  display: block;
  border: 1px solid #ddd;
  height: 120px;
  overflow-y: scroll;
  padding: 2px 4px;
}
.editStratagy__content .editStratagy__center {
  margin-left: 100px;
}
.editStratagy__content .editStratagy__selecet {
  width: 40%;
}
.editStratagy__content .editStratagy__btn--w100 {
  width: 100%;
}
.editStratagy__content .editStratagy__w200 {
  width: 200px;
}
.editStratagy__content .editStratagy__w400 {
  width: 400px;
}
</style>
